module.exports = __webpack_public_path__ + "shop-cart.svg?3a58caedc6dbb682419422701429b116";